// extracted by mini-css-extract-plugin
module.exports = {"container__infos":"Infos_container__infos__DDswi"};